import React from "react";
import "./Loader.css"; // Подключаем стили

const Loader = ({ size = 40, color = "black", speed = 0.9 }) => {
  const containerStyle = {
    "--uib-size": `${size}px`,
    "--uib-color": color,
    "--uib-speed": `${speed}s`,
    "--uib-center": `calc(var(--uib-size) / 2 - var(--uib-size) / 5 / 2)`,
  };

  return (
    <div className="container" style={containerStyle}>
      {[...Array(8)].map((_, index) => (
        <div
          key={index}
          className="dot"
          style={{ transform: `rotate(${index * 45}deg)` }}
        >
          <div className="dot-inner"></div>
        </div>
      ))}
    </div>
  );
};

export default Loader;
